import React from 'react';
import { motion } from 'framer-motion';
export function EmotionalHook() {
  return <section className="py-16 md:py-20 px-4 bg-dark-contrast" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="border-l-4 border-amber pl-6 md:pl-10 py-2" data-id="element-91">
          <p className="text-xl md:text-2xl text-ivory italic mb-8 font-light leading-relaxed" data-id="element-92">
            "It's 6:00 PM on a Saturday..."
          </p>

          <div className="space-y-5 md:space-y-8 text-smoke text-base md:text-xl leading-relaxed" data-id="element-93">
            <p data-id="element-94">
              Your friends and family are gathered around the patio. The beers
              are cold, the conversation is flowing, and everyone is waiting for
              the main event.
            </p>
            <p data-id="element-95">
              You lift the lid. A cloud of smoke clears. You pull the meat off
              and start slicing.
            </p>
            <p data-id="element-96">
              But as the knife goes in, you feel it. The resistance. The brisket
              is tough. The chicken is dangerously pink near the bone. The ribs
              are dry and chewy.
            </p>
            <p data-id="element-97">
              Your guests are politely eating, smiling, telling you "it's
              great!" But you know. They know. You spent $80 on premium meat,
              sacrificed 6 hours of your weekend, and the result is... mediocre
              at best.
            </p>
            <p className="font-bold text-ivory text-xl md:text-2xl mt-10" data-id="element-98">
              Sound familiar? You're not alone. And it's{' '}
              <span className="text-clay" data-id="element-99">NOT your fault.</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}